export class StatusTexts {
	public static getQuoteStatusFromNumber(status: number) {
		switch (status) {
			case 0:
				return "Quote";
			case 1:
				return "Booking";
			case 2:
				return "Confirmed";
			case 3:
				return "Completed";
			case 4:
				return "Cancelled";
			default:
				const msg = `Unknown status '${status}' for Quote!`;
				alert(msg);
				throw new Error(msg);
		}
	}

	public static getQuoteEntryStatusFromNumber(status: number) {
		switch (status) {
			case 0:
				return "Draft";
			case 1:
				return "Pending";
			case 2:
				return "Requested to supplier";
			case 3:
				return "Confirmed";
			case 4:
				return "Cancelled by client";
			case 5:
				return "Denied by supplier";
			case 6:
				return "Cancelled by supplier";
			default:
				const msg = `Unknown status '${status}' for Quote Entry!`;
				alert(msg);
				throw new Error(msg);
		}
	}

	public static getQuoteEntryStatusFromString(status: string) {
		switch (status) {
			case "Draft":
			case "Pending":
			case "Confirmed":
				return status;
			case "Processing":
				return "Requested to supplier";
			case "CancelledByClient":
				return "Cancelled by Client";
			case "DeniedBySupplier":
				return "Denied by Supplier";
			case "CancelledBySupplier":
				return "Cancelled by Supplier";
			default:
				const msg = `Unknown status '${status}' for Quote Entry!`;
				alert(msg);
				throw new Error(msg);
		}
	}

	public static getInvoiceStatusFromNumber(status: number) {
		switch (status) {
			case 0:
				return "Draft";
			case 1:
				return "Accounted";
			case 2:
				return "Paid";
			case 3:
				return "Cancelled";
			default:
				const msg = `Unknown status '${status}' for Quote Entry!`;
				alert(msg);
				throw new Error(msg);
		}
	}

	public static getPaymentStatusFromNumber(status: number) {
		switch (status) {
			case 0:
				return "Draft";
			case 1:
				return "Pending";
			case 2:
				return "Finished";
			case 3:
				return "Failed";
			case 4:
				return "Processing";
			case 6:
				return "Refunded";
			default:
				const msg = `Unknown status '${status}' for Quote Entry!`;
				alert(msg);
				throw new Error(msg);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/status-texts.ts